import {
  CreateLLMModelSpecificationRequest,
  LLMModelSpecification,
  LLMModelSpecificationReorderRequest,
} from 'api/model.ts';
import instance from '../axios_instance';

export const getModelSpecifications = async (provider?: string): Promise<LLMModelSpecification[]> => {
  const url = provider ? `/model-specifications/${provider}` : `/model-specifications`;
  const response = await instance.get<LLMModelSpecification[]>(url);
  return response.data;
};

export const getModelSpecification = async ({
  name,
  provider,
}: {
  name: string;
  provider: string;
}): Promise<LLMModelSpecification> => {
  const response = await instance.get<LLMModelSpecification>(`/model-specifications/${provider}/${name}`);
  return response.data;
};

export const createModelSpecification = async (
  model: CreateLLMModelSpecificationRequest,
): Promise<LLMModelSpecification> => {
  const response = await instance.post<LLMModelSpecification>(`/model-specifications`, model);
  return response.data;
};

export const updateModelSpecification = async ({
  name,
  provider,
  model,
}: {
  name: string;
  provider: string;
  model: CreateLLMModelSpecificationRequest;
}): Promise<LLMModelSpecification> => {
  const response = await instance.patch<LLMModelSpecification>(`/model-specifications/${provider}/${name}`, model);
  return response.data;
};

export const refreshModelSpecifications = async (): Promise<void> => {
  await instance.post<LLMModelSpecification[]>(`/model-specifications/refresh`);
};

export const reorderModelSpecifications = async ({
  provider,
  payload,
}: {
  provider: string;
  payload: LLMModelSpecificationReorderRequest;
}): Promise<void> => {
  await instance.post<LLMModelSpecification[]>(`/model-specifications/${provider}/reorder`, payload);
};

export const removeModelSpecification = async ({
  provider,
  name,
}: {
  provider: string;
  name: string;
}): Promise<void> => {
  await instance.delete(`/model-specifications/${provider}/${name}`);
};

export const syncOllamaModelSpecifications = async (baseUrl: string): Promise<LLMModelSpecification[]> => {
  const response = await instance.post<LLMModelSpecification[]>(`/model-specifications/ollama/sync`, {
    base_url: baseUrl,
  });
  return response.data;
};
